module.exports = __webpack_public_path__ + "static/media/01-4.db8bd2ec.webp";